var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_353_724",
    x1: 14.2721,
    y1: 20.4154,
    x2: 11.2697,
    y2: 3.38949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_353_724",
    x1: 2.43394,
    y1: 13.5919,
    x2: 8.41748,
    y2: 17.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_353_724",
    x1: 7.284,
    y1: 18.3538,
    x2: 3.7368,
    y2: 12.2112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_353_724",
    x1: 1.26171,
    y1: 11.0143,
    x2: 8.53028,
    y2: 15.2098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_353_724",
    x1: 7.18149,
    y1: 16.9817,
    x2: 2.70034,
    y2: 9.22252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_353_724",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.09529 15.4157) scale(2.22557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_353_724",
    x1: 1.29977,
    y1: 7.89427,
    x2: 8.85497,
    y2: 12.2554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_353_724",
    x1: 7.6776,
    y1: 14.2972,
    x2: 2.86834,
    y2: 5.96881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_353_724",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.25799 11.3711) scale(2.63112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_353_724",
    x1: 21.7416,
    y1: 13.7506,
    x2: 15.7581,
    y2: 17.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_353_724",
    x1: 16.8919,
    y1: 18.5122,
    x2: 20.4387,
    y2: 12.3699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_353_724",
    x1: 22.9135,
    y1: 11.1727,
    x2: 15.6449,
    y2: 15.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_353_724",
    x1: 16.9923,
    y1: 17.1398,
    x2: 21.4735,
    y2: 9.38022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_353_724",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4893 14.4366) rotate(180) scale(2.22557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_353_724",
    x1: 22.8758,
    y1: 8.05303,
    x2: 15.3206,
    y2: 12.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_353_724",
    x1: 16.4983,
    y1: 14.4559,
    x2: 21.3075,
    y2: 6.12788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E99F00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_353_724",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5427 12.4148) rotate(180) scale(2.63112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_353_724",
    x1: 13.5134,
    y1: 20.0352,
    x2: 10.764,
    y2: 4.44446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF962E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_353_724",
    x1: 19.0608,
    y1: 19.2213,
    x2: 9.21134,
    y2: 21.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8743FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4136F1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8871 5.86629L22.3361 5.20115C22.2267 5.06915 22.0313 5.05064 21.8993 5.16001L19.3519 7.26824C17.807 4.92378 15.1522 3.37646 12.1351 3.37646C12.1238 3.37646 12.1128 3.37681 12.1015 3.37681C12.0418 3.37681 11.9818 3.37784 11.9215 3.37921H11.9102C11.8841 3.37989 11.8581 3.37989 11.8323 3.38058C8.93349 3.47178 6.39532 4.99201 4.89703 7.25966C4.89429 7.26378 4.8888 7.26446 4.88503 7.26138L2.34446 5.15932C2.21246 5.04995 2.01669 5.06846 1.90731 5.20046L1.35669 5.86561C0.503658 6.89555 0.545486 8.36744 1.38411 9.34664C1.38617 9.34904 1.38686 9.35281 1.38514 9.35589C0.765258 10.4839 1.02343 11.9301 2.06537 12.7649L2.45383 13.0762C2.45657 13.0783 2.4576 13.0821 2.45657 13.0851C2.11406 14.1254 2.42674 15.3147 3.3336 16.0416L6.37646 18.48C7.90149 19.834 9.90892 20.6572 12.1087 20.6572H12.1354C14.3352 20.6572 16.3426 19.8343 17.8677 18.48L20.9105 16.0416C21.8191 15.3137 22.1311 14.1209 21.7858 13.08L22.1787 12.7653C23.2221 11.929 23.4795 10.4798 22.8562 9.35144C23.6986 8.37224 23.7418 6.89761 22.8874 5.86629H22.8871Z",
    fill: "url(#paint0_linear_353_724)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75234 15.7344L2.92286 12.745C2.63897 13.6011 2.89577 14.5821 3.64251 15.1803L7.92857 17.8923L7.75234 15.7347V15.7344Z",
    fill: "url(#paint1_linear_353_724)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9416 17.9143L7.9224 17.9023L3.63634 15.1899C2.90983 14.6074 2.61909 13.6241 2.91223 12.7416L2.91669 12.7275L2.92869 12.7354L7.76331 15.7279V15.7347L7.9416 17.9143ZM2.92903 12.7625C2.64651 13.6323 2.93486 14.5989 3.64971 15.1718L7.91554 17.8711L7.74171 15.7413L2.92937 12.7629L2.92903 12.7625Z",
    fill: "url(#paint2_linear_353_724)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.752 14.2457C7.752 14.2457 3.67508 10.9869 2.04274 9.66104C1.53017 10.5892 1.74171 11.7809 2.59988 12.4684L7.74925 16.5628L7.75268 14.2461L7.752 14.2457Z",
    fill: "url(#paint3_linear_353_724)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75989 16.5867L7.74137 16.5717L2.59234 12.4769C1.74171 11.7953 1.50617 10.6094 2.03246 9.65589L2.03931 9.64389L2.04994 9.65246C3.66343 10.9629 7.7184 14.2042 7.7592 14.2368L7.76057 14.2378L7.76331 14.2413V14.2461L7.75954 16.5867H7.75989ZM2.04617 9.67852C1.53326 10.6203 1.76811 11.7878 2.60709 12.4594L7.73794 16.5391L7.74171 14.2512C7.59669 14.1357 3.6456 10.9769 2.04651 9.67818L2.04617 9.67852Z",
    fill: "url(#paint4_linear_353_724)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M2.92457 12.7197L7.84937 16.523L7.78423 16.6354L3.03497 12.9521C2.95852 12.8921 2.87246 12.8037 2.92389 12.721L2.92457 12.7197Z",
    fill: "url(#paint5_radial_353_724)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73931 14.1884L8.57588 10.692L2.98971 6.30033C2.78503 6.13096 2.48228 6.15942 2.31291 6.3641L2.004 6.73747C1.30183 7.5857 1.33714 8.79839 2.02971 9.60342C4.53394 11.6163 7.73897 14.1884 7.73897 14.1884H7.73931Z",
    fill: "url(#paint6_linear_353_724)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74583 14.2087L7.73177 14.1977C7.73177 14.1977 4.52674 11.6253 2.02251 9.61269C1.30903 8.78401 1.2984 7.57269 1.99543 6.73064L2.304 6.35727C2.388 6.25578 2.50629 6.19304 2.63726 6.18104C2.76994 6.17075 2.89577 6.20847 2.99657 6.29212L8.58857 10.6879L8.5872 10.6948L7.74583 14.209V14.2087ZM2.68389 6.20127C2.66949 6.20127 2.6544 6.2023 2.63932 6.20367C2.51486 6.21532 2.40171 6.27498 2.32149 6.37167L2.01291 6.74504C1.32309 7.57818 1.33371 8.77749 2.03863 9.59658C4.44549 11.5303 7.50103 13.9831 7.73246 14.1689L8.56354 10.6961L2.98251 6.30927C2.89714 6.23864 2.79257 6.20092 2.68354 6.20092L2.68389 6.20127Z",
    fill: "url(#paint7_linear_353_724)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M2.0328 9.60377L7.81611 14.1401L7.75097 14.2526L2.14286 9.83588C2.0664 9.77588 1.98034 9.68742 2.03177 9.6048L2.03246 9.60342L2.0328 9.60377Z",
    fill: "url(#paint8_radial_353_724)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4232 15.8931L21.2527 12.9038C21.5366 13.7599 21.2798 14.7408 20.533 15.3391L16.247 18.0511L16.4232 15.8935V15.8931Z",
    fill: "url(#paint9_linear_353_724)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2339 18.073L16.236 18.0504L16.4129 15.887L16.4177 15.8835L21.2592 12.8863L21.2637 12.9003C21.5565 13.7829 21.2661 14.7665 20.5406 15.348L16.2343 18.073H16.2339ZM16.4338 15.9L16.26 18.0295L20.5265 15.3295C21.24 14.7576 21.5287 13.7911 21.2462 12.9209L16.4338 15.9Z",
    fill: "url(#paint10_linear_353_724)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4232 14.4045C16.4232 14.4045 20.5001 11.1456 22.1325 9.81943C22.645 10.7472 22.4335 11.9393 21.5753 12.6267L16.4259 16.7211L16.4225 14.4045H16.4229H16.4232Z",
    fill: "url(#paint11_linear_353_724)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.415 16.7451V16.7215L16.4115 14.3935H16.4194C16.5521 14.2872 20.5306 11.1058 22.1253 9.81085L22.1359 9.80228L22.1427 9.81428C22.669 10.7671 22.4335 11.954 21.5825 12.6353L16.415 16.7451ZM16.4338 14.4103L16.4373 16.6978L21.5681 12.6182C22.4071 11.9462 22.6419 10.7784 22.1294 9.83725C20.5303 11.136 16.5789 14.2951 16.4342 14.4106L16.4338 14.4103Z",
    fill: "url(#paint12_linear_353_724)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M21.2513 12.8781L16.3265 16.6814L16.3917 16.7938L21.1409 13.1105C21.2174 13.0505 21.3034 12.9621 21.252 12.8794L21.2513 12.8781Z",
    fill: "url(#paint13_radial_353_724)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4366 14.3472L15.6 10.8507L21.1862 6.45908C21.3909 6.28971 21.6936 6.31817 21.863 6.52286L22.1719 6.89623C22.8741 7.74446 22.8391 8.95714 22.1462 9.76217C19.6419 11.7751 16.4369 14.3472 16.4369 14.3472H16.4366Z",
    fill: "url(#paint14_linear_353_724)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4294 14.3671L16.4249 14.3496L15.587 10.8466L15.5928 10.8422L21.179 6.45051C21.2794 6.36651 21.407 6.32605 21.5383 6.33943C21.6693 6.35211 21.7875 6.41485 21.8712 6.51565L22.1805 6.88903C22.8775 7.73074 22.8669 8.94205 22.1547 9.76937C19.6485 11.784 16.4434 14.3558 16.4434 14.3558L16.4294 14.3667V14.3671ZM15.6123 10.8552L16.4431 14.3273C16.6745 14.1418 19.7304 11.6894 22.139 9.7536C22.8422 8.93588 22.8528 7.73657 22.163 6.90343L21.8537 6.53005C21.7742 6.43337 21.661 6.37405 21.5362 6.36205C21.4131 6.34903 21.2894 6.38777 21.1927 6.468L15.6117 10.8555L15.6123 10.8552Z",
    fill: "url(#paint15_linear_353_724)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M22.1431 9.76218L16.3598 14.2985L16.4249 14.411L22.0323 9.9943C22.1091 9.9343 22.1949 9.84584 22.1434 9.76321L22.1427 9.76184L22.1431 9.76218Z",
    fill: "url(#paint16_radial_353_724)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1385 4.40503C7.8192 4.40503 4.3056 7.91966 4.3056 12.24C4.3056 16.5603 7.8192 20.0746 12.1385 20.0746C16.4578 20.0746 19.9714 16.56 19.9714 12.24C19.9714 7.92 16.4578 4.40503 12.1385 4.40503Z",
    fill: "url(#paint17_linear_353_724)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0867 19.2213C15.9384 19.2213 19.0608 16.0982 19.0608 12.2455C19.0608 8.3928 15.9384 5.26971 12.0867 5.26971C8.23509 5.26971 5.11269 8.3928 5.11269 12.2455C5.11269 16.0982 8.23509 19.2213 12.0867 19.2213Z",
    fill: "url(#paint18_linear_353_724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 12.2455C18.8108 15.9602 15.8003 18.9713 12.0867 18.9713C8.37321 18.9713 5.36269 15.9602 5.36269 12.2455C5.36269 8.53082 8.37321 5.51971 12.0867 5.51971C15.8003 5.51971 18.8108 8.53082 18.8108 12.2455Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9222 16.0964C14.8635 16.0964 14.8046 16.0879 14.7463 16.0707L12.0014 15.2592C11.9691 15.2496 11.9355 15.2496 11.904 15.2592L9.192 16.0687C8.9856 16.1304 8.76583 16.0807 8.604 15.9367C8.43669 15.7872 8.36092 15.565 8.40069 15.3422L8.79497 13.1438C8.8056 13.0848 8.78949 13.0227 8.75177 12.9778L7.60594 11.6084C7.47943 11.4572 7.42972 11.2591 7.46983 11.0643C7.50926 10.872 7.63063 10.7115 7.80309 10.6238L9.55577 9.7337C9.57669 9.72308 9.59554 9.70833 9.61166 9.69016L11.5392 7.48079C11.6602 7.34228 11.8344 7.26445 12.0161 7.26719C12.1985 7.26993 12.3699 7.35359 12.4869 7.49622L14.1987 9.59073C14.2149 9.61062 14.2347 9.62673 14.2574 9.63839L16.1657 10.621C16.3382 10.7098 16.4589 10.8713 16.4969 11.0643C16.5353 11.2598 16.4839 11.4583 16.3557 11.6088L15.1862 12.9788C15.1478 13.0241 15.131 13.0865 15.1419 13.1462L15.5362 15.3439C15.5763 15.5664 15.5006 15.7886 15.3339 15.938C15.2181 16.0419 15.072 16.0968 14.9225 16.0968L14.9222 16.0964ZM11.9523 14.8087C12.0113 14.8087 12.0703 14.8172 12.1279 14.8344L14.8725 15.6456C14.953 15.6696 15.011 15.6319 15.0384 15.6072C15.0898 15.5612 15.1131 15.4916 15.1005 15.4217L14.7062 13.224C14.6715 13.032 14.7237 12.8376 14.8495 12.6905L16.019 11.3208C16.0591 11.2738 16.0749 11.2114 16.0629 11.1497C16.0512 11.0904 16.0149 11.041 15.9634 11.0146L14.0547 10.0316C13.9776 9.99188 13.9107 9.93771 13.8562 9.8705L12.1447 7.77668C12.1101 7.7345 12.0624 7.71085 12.0099 7.71016C11.9578 7.70913 11.9091 7.73142 11.8735 7.77222L9.94594 9.98159C9.89211 10.043 9.82903 10.092 9.75737 10.1283L8.00469 11.0184C7.95326 11.0444 7.91692 11.0935 7.90457 11.1528C7.89189 11.2145 7.90732 11.2766 7.94674 11.3239L9.09223 12.6932C9.21497 12.8396 9.26572 13.0323 9.23177 13.2219L8.83749 15.4203C8.8248 15.4906 8.84811 15.5602 8.89989 15.6062C8.92731 15.6308 8.9856 15.6682 9.06583 15.6442L11.7775 14.8351C11.8347 14.8179 11.8937 14.8094 11.9527 14.8094L11.9523 14.8087Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7939 8.75931L10.3851 10.3742C10.3598 10.403 10.3296 10.4263 10.296 10.4434L9.01543 11.0938C8.84229 11.1819 8.79634 11.4144 8.92217 11.5653L9.75909 12.5657C9.81737 12.6353 9.84206 12.7289 9.82594 12.8194L9.53794 14.4257C9.49817 14.6482 9.69943 14.8361 9.91063 14.773L11.892 14.1816C11.9455 14.1655 12.0021 14.1655 12.0555 14.1816L14.0613 14.7747C14.2721 14.8371 14.473 14.6493 14.4329 14.4271L14.1449 12.8215C14.1285 12.7296 14.1535 12.6353 14.2135 12.5654L15.0679 11.5642C15.1958 11.4144 15.1515 11.1806 14.9781 11.0914L13.5837 10.3731C13.5477 10.3546 13.5158 10.3286 13.4901 10.297L12.2393 8.76686C12.1238 8.6256 11.9139 8.62217 11.7939 8.75966V8.75931Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRank);
export default __webpack_public_path__ + "static/media/icon-rank.203be1bb3006b6539a5413ed7b5ac6b7.svg";
export { ForwardRef as ReactComponent };